<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.online_events") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="Id"
            icon-no-border
            label="Id"
            v-model="id"
            @keyup.delete="getAllTeacher()"
          />
        </div>
        <!-- <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-mail"
            placeholder="Email"
            icon-no-border
            label="Email"
            v-model="email"
          />
        </div> -->
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-feather"
            placeholder="Event Name"
            icon-no-border
            label="Event Name"
            v-model="classes"
            @keyup.delete="getAllTeacher()"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllTeacher()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.event_id") }}</vs-th>
          <vs-th>{{ $t("labels.event_title") }}</vs-th>
          <vs-th>{{ $t("labels.date") }}</vs-th>
          <vs-th>{{ $t("labels.start_time") }}</vs-th>
          <vs-th>{{ $t("labels.end_time") }}</vs-th>
          <vs-th>{{ $t("labels.host_name") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td class="word-break" :data="data[indextr].title">
              {{ data[indextr].title }}
            </vs-td>

            <vs-td :data="data[indextr].date">
              {{ data[indextr].date }}
            </vs-td>

            <vs-td :data="data[indextr].starting_time">
              {{ data[indextr].starting_time }}
            </vs-td>

            <vs-td :data="data[indextr].ending_time">
              {{ data[indextr].ending_time }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              <vs-button
                @click.stop="viewDetails(data[indextr].id)"
                size="small"
                title="View"
                class="m-1 float-left"
                color="success"
                icon="icon-eye"
                icon-pack="feather"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    id: "",
    email: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    pageChange: false,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        this.pageChange = true;
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    getAllTeacher() {
      let pageNo = this.currentPage;
      if (this.pageChange == false) {
        if (this.$route.query.page) {
          pageNo = this.$route.query.page;
        }
      }
      let input = {
        id: this.id,
        email: this.email,
        classes: this.classes,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("event/onlineEvents", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.event;
          console.log(this.users);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          } else {
            this.currentPage = parseInt(pageNo);
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.id = ""), (this.email = ""), (this.classes = "");
      this.getAllTeacher();
    },
    BlockUnblock(id, status) {
      this.changeID = id;
      this.sts = status;
      let text = text;
      let title_model = title_model;
      if (status) {
        text = this.$t("strings.block_user");
        title_model = this.$t("labels.block_user");
      } else {
        text = this.$t("strings.unblock_user");
        title_model = this.$t("labels.unblock_user");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: title_model,
        text: text,
        acceptText: this.$t("labels.delete_button"),
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      let input = {
        is_active: !this.sts,
      };
      axios
        .post("user/changeStatus/" + this.changeID, input)
        .then((response) => {
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllTeacher();
          this.changeID = null;
        })
        .catch((e) => {
          this.changeID = null;
          this.showError(e);
        });
    },
    DeleteAccount(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_user"),
        text: this.$t("strings.delete_user"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      let input = {
        user_id: this.deleteID,
      };
      axios
        .post("user/deleteAccount", input)
        .then((response) => {
          let data = response.data;
          this.getAllStudents();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    viewDetails(id) {
      this.$router.push("events/view/" + id + "?page=" + this.currentPage);
    },
  },
  mounted() {
    this.getAllTeacher();
  },
};
</script>

<style lang="scss" scoped>
</style>